var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back-box"},[_c('div',{staticClass:"back-btn",on:{"click":_vm.onBack}},[_c('i',{staticClass:"el-icon-arrow-left"})]),_c('div',{staticClass:"back-title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"back-help"})])
}
var staticRenderFns = []

export { render, staticRenderFns }